<tec-base>
    <tec-topnav
        [img]="(designService.configDesign$ | async)?.logo || 'assets/images/tecalis-lg' + (designService.isDarkMode() ? '-dark' : '') + '.svg'"
        [title]="getTopnavProductTitle(designService.configDesign$ | async)">
		@if (!isMdSize) {
		<tec-link (click)="isSensitivePersonalDataVisible = true">
			<tec-icon name="icon-shield"></tec-icon>
			{{ 'HOME.SENSITIVE_PERSONAL_DATA_TITLE' | translate}}
		</tec-link>
		}
		<ng-container [formGroup]="languageForm">
			<div class="home-topnav-lang">
				<tec-select [options]="languageSelectOptions" formControlName="locale"></tec-select>
			</div>
		</ng-container>
	</tec-topnav>
    <div id="content" class="content-pwcs-home">
		@let processConfig = (configService.config$ | async);
		<tec-process-layout
			[title]="'HOME.TITLE' | translate"
			[subtitle]="getHomeSubtitle()">
			<ng-container left-section>
				<div class="content__section">
					<div class="stepper-info-item">
						@for (op of operations; track op; let i = $index) {
							<!-- OCR -->
							@if (op.type === operationType.OCR) {
								<div class="stepper-info-item__item">
									<div class="stepper-info-item__item__image">
										<div class="image__wrapper">
											<pwcs-inline-svg
												[src]="'assets/images/home-ocr' + (designService.isDarkMode() ? '-dark' : '') + '.svg'"
												[alt]="'HOME.DOCUMENT_CHECK_STEP' | translate"
												[idSuffix]="i"
												[cssClass]="'pwcs-stepper-svg pwcs-stepper-svg--ocr' + (op.config?.dni_wireframe_photo_side === 'right' ? ' pwcs-stepper-svg--ocr-right' : '')"
											/>
										</div>
										<tec-divider></tec-divider>
									</div>
									<span class="stepper-info-item__item__text" [innerHTML]="'HOME.DOCUMENT_CHECK_STEP' | translate"></span>
								</div>
							}
							<!-- PoL -->
							@if (op.type === operationType.POL) {
								<div class="stepper-info-item__item">
									<div class="stepper-info-item__item__image">
										<div class="image__wrapper">
											<pwcs-inline-svg
												[src]="'assets/images/home-pol' + (designService.isDarkMode() ? '-dark' : '') + '.svg'"
												[alt]="'HOME.LIFE_CHECK_STEP' | translate"
												[idSuffix]="i"
												cssClass="pwcs-stepper-svg pwcs-stepper-svg--pol"
											/>
										</div>
										<tec-divider></tec-divider>
									</div>
									<span class="stepper-info-item__item__text" [innerHTML]="'HOME.LIFE_CHECK_STEP' | translate"></span>
								</div>
							}
							<!-- Attorney Powers -->
							@if ((op.type === operationType.CONNECTIONS && op.config.type === CONNECTION_TYPE.SCRIPTURE) || (op.type === operationType.DOCUMENTS && hasAttorneyPowersLikeDocs())) {
								<div class="stepper-info-item__item">
									<div class="stepper-info-item__item__image">
										<div class="image__wrapper">
											<pwcs-inline-svg
												[src]="'assets/images/home-attorney-powers' + (designService.isDarkMode() ? '-dark' : '') + '.svg'"
												[alt]="'HOME.ATTORNEY_POWERS_STEP' | translate"
												[idSuffix]="i"
												cssClass="pwcs-stepper-svg pwcs-stepper-svg--attorney-powers"
											/>
										</div>
										<tec-divider></tec-divider>
									</div>
									<span class="stepper-info-item__item__text" [innerHTML]="'HOME.ATTORNEY_POWERS_STEP' | translate"></span>
								</div>
							}
							<!-- Documents -->
							@if (op.type === operationType.DOCUMENTS && !hasAttorneyPowersLikeDocs()) {
								<div class="stepper-info-item__item">
									<div class="stepper-info-item__item__image">
										<div class="image__wrapper">
											<pwcs-inline-svg
												[src]="'assets/images/home-docs' + (designService.isDarkMode() ? '-dark' : '') + '.svg'"
												[alt]="'HOME.DOCUMENTS_STEP' | translate"
												[idSuffix]="i"
												cssClass="pwcs-stepper-svg pwcs-stepper-svg--docs"
											/>
										</div>
										<tec-divider></tec-divider>
									</div>
									@if (op.config?.docs?.length === 1) {
										<span class="stepper-info-item__item__text" [innerHTML]="getDocumentsStepText(op)"></span>
									}
									@if (op.config?.docs?.length > 1) {
										<span class="stepper-info-item__item__text" [innerHTML]="'HOME.DOCUMENTS_STEP' | translate"></span>
									}
								</div>
							}
							<!-- Choose -->
							@if (op.type === operationType.CHOOSE) {
								<div class="stepper-info-item__item">
									<div class="stepper-info-item__item__image">
										<div class="image__wrapper">
											<pwcs-inline-svg
												[src]="'assets/images/' + getChooseInfo(op)?.img + (designService.isDarkMode() ? '-dark' : '') + '.svg'"
												[alt]="getChooseInfo(op)?.label"
												[idSuffix]="i"
												cssClass="pwcs-stepper-svg pwcs-stepper-svg--choose"
											/>
										</div>
										<tec-divider></tec-divider>
									</div>
									<span class="stepper-info-item__item__text" [innerHTML]="getChooseInfo(op)?.label"></span>
								</div>
							}
							<!-- FORM -->
							@if (op.type === operationType.FORM) {
								<div class="stepper-info-item__item">
									<div class="stepper-info-item__item__image">
										<div class="image__wrapper">
											<pwcs-inline-svg
												[src]="'assets/images/home-form' + (designService.isDarkMode() ? '-dark' : '') + '.svg'"
												[alt]="'HOME.FORM_STEP' | translate"
												[idSuffix]="i"
												cssClass="pwcs-stepper-svg pwcs-stepper-svg--form"
											/>
										</div>
										<tec-divider></tec-divider>
									</div>
									<span class="stepper-info-item__item__text" [innerHTML]="'HOME.FORM_STEP' | translate"></span>
								</div>
							}
							<!-- Connections -->
							@if (op.type === operationType.CONNECTIONS && op.config.type !== CONNECTION_TYPE.SCRIPTURE) {
								@if (op.config.type === CONNECTION_TYPE.BANK_SCORING || op.config.evaluation) {
									<div class="stepper-info-item__item">
										<div class="stepper-info-item__item__image">
											<div class="image__wrapper">
												<pwcs-inline-svg
													[src]="'assets/images/home-connection-bank' + (designService.isDarkMode() ? '-dark' : '') + '.svg'"
													[alt]="'HOME.CONNECTIONS_BANK_STEP' | translate"
													[idSuffix]="i"
													cssClass="pwcs-stepper-svg pwcs-stepper-svg--connection-bank"
												/>
											</div>
											<tec-divider></tec-divider>
										</div>
										@if (op.config.type === CONNECTION_TYPE.BANK_SCORING && op.config.evaluation === EVALUATION_TYPE.MATCH_DATA) {
											<span class="stepper-info-item__item__text" [innerHTML]="'HOME.CONNECTIONS_BANK_STEP_MATCH_DATA' | translate"></span>
										} @else {
											<span class="stepper-info-item__item__text" [innerHTML]="'HOME.CONNECTIONS_BANK_STEP' | translate"></span>
										}
									</div>
								} @else {
									<div class="stepper-info-item__item">
										<div class="stepper-info-item__item__image">
											<div class="image__wrapper">
												<pwcs-inline-svg
													[src]="'assets/images/home-docs' + (designService.isDarkMode() ? '-dark' : '') + '.svg'"
													[alt]="'HOME.CONNECTIONS_STEP' | translate"
													[idSuffix]="i"
													cssClass="pwcs-stepper-svg pwcs-stepper-svg--docs"
												/>
											</div>
											<tec-divider></tec-divider>
										</div>
										<span class="stepper-info-item__item__text" [innerHTML]="'HOME.CONNECTIONS_STEP' | translate: {connectionName: ('CONNECTIONS.TYPES.' + op.config.type?.toUpperCase() | translate)}"></span>
									</div>
								}
							}
						}
						<div class="stepper-info-item__item" [class.hidden-sm]="operations.length % 2 === 0 || operations.length <= 3">
							<div class="stepper-info-item__item__image">
								<div class="image__wrapper">
									<pwcs-inline-svg
										[src]="'assets/images/home-finish' + (designService.isDarkMode() ? '-dark' : '') + '.svg'"
										[alt]="'HOME.FINISH_STEP' | translate"
										idSuffix="finish"
										cssClass="pwcs-stepper-svg pwcs-stepper-svg--finish"
									/>
								</div>
							</div>
							<span class="stepper-info-item__item__text hidden-lg show-sm" [innerHTML]="'HOME.FINISH_STEP' | translate"></span>
						</div>
					</div>
				</div>
				<div class="content__section">
					@if (operationsWithDocuments?.length) {
					<tec-alert
						class="full-width-mobile"
						[msg]="'HOME.DOCS_ALERT' | translate"
						[status]="'default'"
						[type]="'message'"
						[status]="'warning'"
						icon="icon-info"
						hiddenCloseButton
					/>
					}
					@if (onlyPolOperation) {
					<tec-alert
						[msg]="'HOME.POL_ALERT' | translate"
						[status]="'default'"
						icon="icon-info"
						[type]="'message'"
						[status]="'warning'"
						hiddenCloseButton
					/>
					}
					<div class="collapse-group">
						@for (op of operations; track op; let i = $index) {
							<!-- OCR -->
							@if (op.type === operationType.OCR) {
							<tec-collapse
								[title]="'HOME.OCR_TITLE' | translate"
								[expanded]="expandedCollapseType === op.type"
								(clickEvent)="toggleCollapse(op.type, $event)"
								secondary>
								<div>
									@if (isEudiOnlyOcr(op)) {
										<p><strong>{{ 'HOME.EUDI_ONLY_TITLE' | translate }}</strong></p>
										<ul>
											<li>{{ 'HOME.EUDI_ONLY_ITEM' | translate }}</li>
										</ul>
									} @else if (isSpanishCompany()) {
										<div class="item-group">
										<p><strong>{{ 'HOME.WHAT_DOCUMENTS_TO_USE' | translate }}</strong></p>
										@if (isDniForOtherCountries(op) || isPassportForOtherCountries(op)) {
											<div>
											<p><strong>{{ 'HOME.DOCS_ISSUED_BY_OTHER_COUNTRIES' | translate }}</strong></p>
											<ul>
												@if (isDniForOtherCountries(op)) {
												<li>
													<span>
														{{ 'OCR.GENERAL.DOCUMENT_TYPE.DNI_EUROPEAN' | translate }}
														<tec-icon
															name="icon-info"
															style="cursor: pointer;"
															[size]="'xs'"
															(click)="isAllowedDocs = {visible: true, type: 'dni', dniScope: 'european', operation: op}"
														></tec-icon>
													</span>
												</li>
												}
												@if (isPassportForOtherCountries(op)) {
												<li>
													<span>
														{{ 'OCR.GENERAL.DOCUMENT_TYPE.PASSPORT' | translate }}
														<tec-icon
															name="icon-info"
															style="cursor: pointer;"
															[size]="'xs'"
															(click)="isAllowedDocs = {visible: true, type: 'passport', operation: op}"
														></tec-icon>
													</span>
												</li>
												}
											</ul>
											</div>
										}
										@if (isDniForSpain(op) || isPassportForSpain(op)) {
											<div>
											<p><strong>{{ 'HOME.DOCS_ISSUED_BY_SPAIN' | translate }}</strong></p>
											<ul>
												@if (isDniForSpain(op)) {
												<li>
													<span>
														{{ 'DOCUMENTS.TYPES.DNI' | translate }}
														<tec-icon
															name="icon-info"
															style="cursor: pointer;"
															[size]="'xs'"
															(click)="isAllowedDocs = {visible: true, type: 'dni', dniScope: 'spain', operation: op}"
														></tec-icon>
													</span>
												</li>
												}
												@if (isPassportForSpain(op)) {
												<li>
													<span>
														{{ 'OCR.GENERAL.DOCUMENT_TYPE.PASSPORT' | translate }}
														<tec-icon
															name="icon-info"
															style="cursor: pointer;"
															[size]="'xs'"
															(click)="isAllowedDocs = {visible: true, type: 'passport', operation: op}"
														></tec-icon>
													</span>
												</li>
												}
											</ul>
											</div>
										}
										</div>
										@if (isDniForOtherCountries(op) && op.config.required_check_nie) {
										<ul>
											<li>
												<span class="home-allowed-docs-cert-line">
													{{ 'HOME.OPTIONAL_MARK' | translate }}
													{{ 'DOCUMENTS.TYPES.CERT_REG_CIU_UE' | translate }}
													<tec-tooltip
														[label]="'HOME.ALLOWED_DOCS_DNI_GREEN_CARD_NOTE' | translate"
														position="right">
														<tec-icon name="icon-info" size="xs"></tec-icon>
													</tec-tooltip>
												</span>
											</li>
										</ul>
										}
										@if (op.config.allowed_docs.nie) {
										<ul>
											<li>{{ 'OCR.GENERAL.DOCUMENT_TYPE.NIE' | translate }}</li>
										</ul>
										}
										@if (op.config.allowed_docs.nie && op.config.required_check_nie) {
										<ul>
											<li>{{ 'DOCUMENTS.TYPES.CERT_REG_CIU_UE' | translate }}</li>
										</ul>
										}
										@if (isEudiWalletEnabled(op)) {
										<ul>
											<li>{{ 'HOME.EUDI_ONLY_ITEM' | translate }}</li>
										</ul>
										}
									} @else {
										{{ 'HOME.DOCUMENT_ALLOWED_TITLE' | translate }}
										<ul>
											@if (op.config.allowed_docs.dni) {
											<li>
												<span>
													{{ getOcrAllowedDniText(op) }}
													<tec-icon
														name="icon-info"
														style="cursor: pointer;"
														[size]="'xs'"
														(click)="isAllowedDocs = {visible: true, type: 'dni', operation: op}"
													></tec-icon>
												</span>
											</li>
											}
											@if (op.config.allowed_docs.dni && op.config.required_check_nie) {
											<li>
												<span class="home-allowed-docs-cert-line">
													{{ 'HOME.OPTIONAL_MARK' | translate }}
													{{ 'DOCUMENTS.TYPES.CERT_REG_CIU_UE' | translate }}
													<tec-tooltip
														[label]="'HOME.ALLOWED_DOCS_DNI_GREEN_CARD_NOTE' | translate"
														position="right">
														<tec-icon name="icon-info" size="xs"></tec-icon>
													</tec-tooltip>
												</span>
											</li>
											}
											@if (op.config.allowed_docs.nie) {
											<li>{{ 'OCR.GENERAL.DOCUMENT_TYPE.NIE' | translate }}</li>
											}
											@if (op.config.allowed_docs.nie && op.config.required_check_nie) {
											<li>{{ 'DOCUMENTS.TYPES.CERT_REG_CIU_UE' | translate }}</li>
											}
											@if (op.config.allowed_docs.passport) {
											<li>
												<span>
													{{ 'OCR.GENERAL.DOCUMENT_TYPE.PASSPORT' | translate }}
													<tec-icon
														name="icon-info"
														style="cursor: pointer;"
														[size]="'xs'"
														(click)="isAllowedDocs = {visible: true, type: 'passport', operation: op}"
													></tec-icon>
												</span>
											</li>
											}
											@if (isEudiWalletEnabled(op)) {
											<li>{{ 'HOME.EUDI_ONLY_ITEM' | translate }}</li>
											}
										</ul>
									}
								</div>
							</tec-collapse>
							}
							<!-- POL -->
							@if (op.type === operationType.POL && onlyPolOperation) {
							<tec-collapse
								[title]="'HOME.POL_TITLE' | translate"
								[expanded]="expandedCollapseType === op.type"
								(clickEvent)="toggleCollapse(op.type, $event)"
								secondary>
								<div>
									{{ 'HOME.POL_SUBTITLE' | translate }}
									<ul>
										<li>{{ 'HOME.POL_INSTRUCTIONS_1' | translate }}</li>
									</ul>
								</div>
							</tec-collapse>
							}
							<!-- Attorney Powers -->
							@if ((op.type === operationType.CONNECTIONS && op.config.type === CONNECTION_TYPE.SCRIPTURE) || (op.type === operationType.DOCUMENTS && hasAttorneyPowersLikeDocs())) {
							<tec-collapse
								[title]="'HOME.ATTORNEY_POWERS_TITLE' | translate"
								[expanded]="expandedCollapseType === op.type"
								(clickEvent)="toggleCollapse(op.type, $event)"
								secondary>
								<div>
									{{ 'HOME.ATTORNEY_POWERS_SUBTITLE' | translate }}
									<ul>
										<li>
											<ng-container
												[ngTemplateOutlet]="connections"
												[ngTemplateOutletContext]="{ connection: CONNECTION_TYPE.SCRIPTURE, op: op }"
											></ng-container>
										</li>
									</ul>
								</div>
							</tec-collapse>
							}
							<!-- DOCS -->
							@if (op.type === operationType.DOCUMENTS && !hasAttorneyPowersLikeDocs()) {
							<tec-collapse
								[title]="'HOME.DOCS_TITLE' | translate"
								[expanded]="expandedCollapseType === op.type"
								(clickEvent)="toggleCollapse(op.type, $event)"
								secondary>
								<div>
									{{ 'HOME.DOCS_SUBTITLE' | translate }}
									<ul>
										@for (doc of op.config?.docs; track doc) {
										<li>
											<ng-container
												[ngTemplateOutlet]="docs"
												[ngTemplateOutletContext]="{ doc: doc, op: op }"
											></ng-container>
										</li>
										}
									</ul>
								</div>
							</tec-collapse>
							}
							<!-- CHOOSE -->
							@if (op.type === operationType.CHOOSE) {
							<tec-collapse
								[title]="'HOME.CHOOSE_TITLE' | translate"
								[expanded]="expandedCollapseType === op.type"
								(clickEvent)="toggleCollapse(op.type, $event)"
								secondary>
								<div>
									{{ 'HOME.CHOOSE_SUBTITLE' | translate }}
									<ul>
										@for (chooseOperation of op.config?.operations; track chooseOperation) {
											@if (chooseOperation.type === operationType.DOCUMENTS) {
												@for (doc of chooseOperation.config?.docs; track doc) {
												<li>
													<ng-container
														[ngTemplateOutlet]="docs"
														[ngTemplateOutletContext]="{ doc: doc, op: chooseOperation }"
													></ng-container>
												</li>
												}
											}
											@if (chooseOperation.type === operationType.CONNECTIONS) {
												<li>
													<ng-container
														[ngTemplateOutlet]="connections"
														[ngTemplateOutletContext]="{ connection: chooseOperation.config.type, op: chooseOperation }"
													></ng-container>
												</li>
											}
											@if (chooseOperation.type === operationType.OCR) {
												<li>{{ 'HOME.CHOOSE_OCR' | translate }}</li>
											}
											@if (chooseOperation.type === operationType.POL) {
												<li>{{ 'HOME.CHOOSE_POL' | translate }}</li>
											}
										}
									</ul>
								</div>
							</tec-collapse>
							}
							<!-- CONNECTIONS -->
							@if (op.type === operationType.CONNECTIONS && op.config.type !== CONNECTION_TYPE.SCRIPTURE) {
								<tec-collapse
									[title]="op.config.type === CONNECTION_TYPE.BANK_SCORING || op.config.evaluation
									    ? ('HOME.CONNECTIONS_BANK_TITLE' | translate) : ('HOME.CONNECTIONS_TITLE' | translate)"
									[expanded]="expandedCollapseType === op.type"
									(clickEvent)="toggleCollapse(op.type, $event)"
									secondary>
									<div>
										{{
											op.config.type === CONNECTION_TYPE.BANK_SCORING && op.config.evaluation === EVALUATION_TYPE.SCORING ?
											('HOME.CONNECTIONS_SUBTITLE_BANK' | translate) :
											('HOME.CONNECTIONS_SUBTITLE' | translate)
										}}
										<ul>
											<li>
												<ng-container
													[ngTemplateOutlet]="connections"
													[ngTemplateOutletContext]="{ connection: op.config.type, op: op }"
												></ng-container>
											</li>
										</ul>
									</div>
								</tec-collapse>
							}
						}
					</div>
				</div>
			</ng-container>
			<ng-container right-section>
				<!-- Dispositivo permitido -->
				@if (processConfig?.isDeviceAllowed) {
					<tec-tile class="hidden-lg"
						[title]="'HOME.INSTR_CONDITIONS_1' | translate"
						type="confirm">
						<div class="button-collapse-group">
							@if (processConfig?.allowed_device?.includes('mobile')) {
							<tec-button-collapse [title]="'HOME.INSTR_CONDITIONS_8' | translate"
								icon="icon-smartphone"
								[expanded]="expanded"
								(clickEvent)="expanded = !expanded">
								<span class="text-align-center">{{ 'HOME.INSTR_CONDITIONS_2' | translate}}</span>
								<tec-tag class="text-align-center" [label]="'HOME.INSTR_CONDITIONS' | translate" status="success"></tec-tag>
								<tec-qr [url]="auth.getQRUrl()" [copyLabel]="'HOME.INSTR_CONDITIONS_3' | translate" />
							</tec-button-collapse>
							}
							<tec-button-collapse
								[title]="'HOME.INSTR_CONDITIONS_4' | translate"
								icon="icon-capture-opened-window"
								[expanded]="!expanded"
								(clickEvent)="expanded = !expanded">
								<div class="toggle-accept-group">
									@if (operation.config.tecalis_policy_check) {
									<div>
										<tec-toggle-accept
											[options]="options['tecalis_default_check_1']"
											(changeValue)="changeValue('tecalis_default_check_1', $event)"
											[vertical]="true"
											[label]="'HOME.INSTR_CONDITIONS_5' | translate"
											[required]="hasError('tecalis_default_check_1')"
										></tec-toggle-accept>
									</div>
									}
									@if (operation.config?.policy_checks?.length) {
										@for (policy of operation.config?.policy_checks; track policy) {
										<div>
											<tec-toggle-accept
												[options]="options[policy.uuid]"
												(changeValue)="changeValue(policy.uuid, $event)"
												[vertical]="true"
												[label]="normalizePolicyLabelHtml(policy.html)"
												[required]="hasError(policy.uuid)"
											></tec-toggle-accept>
										</div>
										}
									}
								</div>
								<tec-button
									[label]="'GENERAL.BUTTON.START' | translate"
									(clickEvent)="nextOperation()"
									[size]="'lg'"
								></tec-button>
							</tec-button-collapse>
						</div>
					</tec-tile>
					<tec-tile class="show-lg" type="confirm">
						@if (operation.config.tecalis_policy_check) {
						<div>
							<tec-toggle-accept
								[options]="options['tecalis_default_check_1']"
								(changeValue)="changeValue('tecalis_default_check_1', $event)"
								[label]="'HOME.INSTR_CONDITIONS_5' | translate"
								[required]="hasError('tecalis_default_check_1')"
							></tec-toggle-accept>
						</div>
						}
						@if (operation.config?.policy_checks?.length) {
							@for (policy of operation.config?.policy_checks; track policy) {
							<div>
								<tec-toggle-accept
									[options]="options[policy.uuid]"
									(changeValue)="changeValue(policy.uuid, $event)"
									[label]="normalizePolicyLabelHtml(policy.html)"
									[required]="hasError(policy.uuid)"
								></tec-toggle-accept>
							</div>
							}
						}
					</tec-tile>
				}
                <!-- Dispositivo no permitido (solo con config cargada; si config es null, no mostrar — evita flash de INSTR_CONDITIONS_9) -->
                @if (processConfig && !processConfig.isDeviceAllowed) {
                    <tec-tile
                        [title]="
						`HOME.INSTR_CONDITIONS_${processConfig?.allowed_device?.includes('mobile')
                                ? '9'
                                : '11'}` | translate
                        "
                        type="confirm"
                    >
                        <span
                            [innerHTML]="
                                `HOME.INSTR_CONDITIONS_${processConfig?.allowed_device?.includes('mobile')
                                    ? '10'
                                    : '12'
                                }` | translate
                            "
                        ></span>
                        <tec-qr [url]="auth.getQRUrl()" [copyLabel]="'HOME.INSTR_CONDITIONS_3' | translate" />
                    </tec-tile>
                }
			</ng-container>
		</tec-process-layout>
		@if (processConfig?.isDeviceAllowed) {
		<tec-footer-actions class="show-lg">
			<tec-button
				[label]="'GENERAL.BUTTON.START' | translate"
				(clickEvent)="nextOperation(true)"
				[size]="'lg'"
			></tec-button>
		</tec-footer-actions>
		}
		@if ((designService.configDesign$ | async)?.showWatermark) {
			<tec-watermark type="default" />
		}
    </div>
</tec-base>

<tec-modal
	[isVisible]="isSensitivePersonalDataVisible"
	[title]="'HOME.SENSITIVE_PERSONAL_DATA_TITLE' | translate"
	(closeEvent)="isSensitivePersonalDataVisible = false">
	<ng-container body>
		<div class="image-icon-group">
			<tec-icon name="icon-shield" size="md"></tec-icon>
			<tec-info-group [label]="'HOME.MODAL_OPTION_1_TITLE' | translate">
				<span [innerHTML]="'HOME.MODAL_OPTION_1_BODY' | translate"></span>
			</tec-info-group>
		</div>
		<tec-divider></tec-divider>
		<div class="image-icon-group">
			<tec-icon name="icon-lock" size="md"></tec-icon>
			<tec-info-group [label]="'HOME.MODAL_OPTION_2_TITLE' | translate">
				<span [innerHTML]="'HOME.MODAL_OPTION_2_BODY' | translate"></span>
			</tec-info-group>
		</div>
		<div class="logos-grid">
			<pwcs-inline-svg
				[src]="'assets/images/iso-9001' + (designService.isDarkMode() ? '-dark' : '') + '.svg'"
				alt="ISO 9001"
				idSuffix="cert-iso-9001"
			/>
			<pwcs-inline-svg
				[src]="'assets/images/iso-27001' + (designService.isDarkMode() ? '-dark' : '') + '.svg'"
				alt="ISO 27001"
				idSuffix="cert-iso-27001"
			/>
			<pwcs-inline-svg
				[src]="'assets/images/eidas' + (designService.isDarkMode() ? '-dark' : '') + '.svg'"
				alt="eIDAS"
				idSuffix="cert-eidas"
			/>
			<pwcs-inline-svg
				[src]="'assets/images/cert-75858' + (designService.isDarkMode() ? '-dark' : '') + '.svg'"
				alt="Certification 75858"
				idSuffix="cert-75858"
			/>
			<pwcs-inline-svg
				[src]="'assets/images/ens' + (designService.isDarkMode() ? '-dark' : '') + '.svg'"
				alt="ENS"
				idSuffix="cert-ens"
			/>
		</div>
	</ng-container>
</tec-modal>


<tec-modal
	[isVisible]="isAllowedDocs.visible"
	[title]="getAllowedDocsModalTitle()"
	(closeEvent)="isAllowedDocs.visible= false">
	<ng-container body>
		<div class="text-align-center column--32g">
			@if (isAllowedDocs.type === 'dni') {
				@if (isSpanishCompany() && isAllowedDocs.dniScope === 'european') {
					<tec-alert
						[msg]="'HOME.SPANISH_COMPANY_DOCS_HELP' | translate"
						type="message"
						icon="icon-info"
						hiddenCloseButton
					/>
					@if (isAllowedDocs?.operation.config?.not_allowed_docs?.dni?.length) {
					<span>
						{{ 'OCR.GENERAL.DOCUMENT_ID_EXCLUDE_THIS_COUNTRIES' | translate }}
						@for (country of isAllowedDocs?.operation.config?.not_allowed_docs?.dni; track country; let isLast = $last; let isFirst = $first) {
							@if (!isLast && !isFirst) {, }
							@if (isAllowedDocs?.operation.config?.not_allowed_docs?.dni?.length > 1 && isLast) {
								{{ 'GENERAL.AND' | translate }}
							}
							{{ ('COUNTRIES.' + country.toUpperCase() | translate) }}
						}
					</span>
					} @else if (isAllowedDocs?.operation.config?.allowed_docs?.dni?.length) {
					<span>
						{{ 'OCR.GENERAL.DOCUMENT_ID_ACCEPT_THIS_COUNTRIES' | translate }}
						@for (country of isAllowedDocs?.operation.config?.allowed_docs?.dni; track country; let isLast = $last; let isFirst = $first) {
							@if (!isLast && !isFirst) {, }
							@if (isAllowedDocs?.operation.config?.allowed_docs?.dni?.length > 1 && isLast) {
								{{ 'GENERAL.AND' | translate }}
							}
							{{ ('COUNTRIES.' + country.toUpperCase() | translate) }}
						}
					</span>
					} @else {
					<span>{{ 'HOME.SPANISH_COMPANY_DNI_EUROPEAN_ACCEPT' | translate }}</span>
					}
				} @else if (isSpanishCompany() && isAllowedDocs.dniScope === 'spain') {
					<span>
						{{ 'OCR.GENERAL.DOCUMENT_ID_ACCEPT_THIS_COUNTRIES' | translate }}
						{{ 'COUNTRIES.ESP' | translate }}
					</span>
				} @else {
				<!-- EXCLUIR ALGÚN PAIS -->
				@if (isAllowedDocs?.operation.config?.not_allowed_docs?.dni?.length) {
					<span>
						{{ 'OCR.GENERAL.DOCUMENT_ID_EXCLUDE_THIS_COUNTRIES' | translate }}
						@for (country of isAllowedDocs?.operation.config?.not_allowed_docs?.dni; track country; let isLast = $last; let isFirst = $first) {
							@if (!isLast && !isFirst) {, }
							@if (isAllowedDocs?.operation.config?.not_allowed_docs?.dni?.length > 1 && isLast) {
								{{ 'GENERAL.AND' | translate }}
							}
							{{ ('COUNTRIES.' + country.toUpperCase() | translate) }}
						}
					</span>
				} @else {
					<!-- TODOS O ALGÚN PAIS -->
					<!-- TODOS LOS PAISES -->
					@if (isAllowedDocs?.operation.config?.allowed_docs?.dni?.length === 0) {
						<span>
							{{ 'OCR.GENERAL.DOCUMENT_ID_ACCEPT_ALL_COUNTRIES' | translate }}
						</span>
					}
					<!-- ALGUNOS PAISES -->
					@if (isAllowedDocs?.operation.config?.allowed_docs?.dni?.length) {
						<span>
							{{ 'OCR.GENERAL.DOCUMENT_ID_ACCEPT_THIS_COUNTRIES' | translate }}
							@for (country of isAllowedDocs?.operation.config?.allowed_docs?.dni; track country; let isLast = $last; let isFirst = $first) {
								@if (!isLast && !isFirst) {, }
								@if (isAllowedDocs?.operation.config?.allowed_docs?.dni?.length > 1 && isLast) {
									{{ 'GENERAL.AND' | translate }}
								}
								{{ ('COUNTRIES.' + country.toUpperCase() | translate) }}
							}
						</span>
					}
				}
				}
				<img [src]="getDniPhotoSideAsset('assets/images/home-dni.png')" width="292" alt="home-dni">
			}
			@if (isAllowedDocs.type === 'passport') {
				<!-- EXCLUIR ALGÚN PAIS -->
				@if (isAllowedDocs?.operation.config?.not_allowed_docs?.passport?.length) {
					<span>
						{{ 'OCR.GENERAL.PASSPORT_EXCLUDE_THIS_COUNTRIES' | translate }}
						@for (country of isAllowedDocs?.operation.config?.not_allowed_docs?.passport; track country; let isLast = $last; let isFirst = $first) {
							@if (!isLast && !isFirst) {, }
							@if (isAllowedDocs?.operation.config?.not_allowed_docs?.passport?.length > 1 && isLast) {
								{{ 'GENERAL.AND' | translate }}
							}
							{{ ('COUNTRIES.' + country.toUpperCase() | translate) }}
						}
					</span>
				}
				@else {
					<!-- TODOS O ALGÚN PAIS -->
					<!-- TODOS LOS PAISES -->
					@if (isAllowedDocs?.operation.config?.allowed_docs?.passport?.length === 0) {
						<span>
							{{ 'OCR.GENERAL.PASSPORT_ACCEPT_ALL_COUNTRIES' | translate }}
						</span>
					}
					<!-- ALGUNOS PAISES -->
					@if (isAllowedDocs?.operation.config?.allowed_docs?.passport?.length) {
						<span>
							{{ 'OCR.GENERAL.PASSPORT_ACCEPT_THIS_COUNTRIES' | translate }}
							@for (country of isAllowedDocs?.operation.config?.allowed_docs?.passport; track country; let isLast = $last; let isFirst = $first) {
								@if (!isLast && !isFirst) { , }
								@if (isAllowedDocs?.operation.config?.allowed_docs?.passport?.length > 1 && isLast) {
									{{ 'GENERAL.AND' | translate }}
								}
								{{ ('COUNTRIES.' + country.toUpperCase() | translate) }}
							}
						</span>
					}
				}
				<img src="assets/images/home-passport.png" width="292" alt="home-passport">
			}
		</div>
	</ng-container>
</tec-modal>

<app-modal-instructions
    [ngClass]="{ dark: designService.isDarkMode() }"
    [(isVisible)]="isVisibleDocInstructions"
    [doc]="selectedDoc"
></app-modal-instructions>

<app-modal-connections-instructions
    [ngClass]="{ dark: designService.isDarkMode() }"
    [(isVisible)]="isVisibleConnectionInstructions"
    [connectionType]="selectedConnectionType"
></app-modal-connections-instructions>

<ng-template #docs let-doc="doc" let-op="op">
	<span>{{ resolveText(doc.title) || ("DOCUMENTS.TYPES." + doc.type) | translate }}</span>
	@if (doc?.required && op.config?.docs.length > 1 && !areAllDocsRequired(op)) {
		<span class="required-indicator">&nbsp;{{ 'DOCUMENTS.REQUIRED_PARENTHESES' | translate }}</span>
	}
	@if (hasDocumentInstructions(doc)) {&nbsp;<tec-icon
			name="icon-info"
			style="cursor: pointer;"
			[size]="'xs'"
			(click)="openDocInstructionsModal(doc)"
		></tec-icon>
	}
</ng-template>

<ng-template #connections let-connection="connection" let-op="op">
	<span>{{ "CONNECTIONS.TYPES." + connection?.toUpperCase() | translate }}</span>
	&nbsp;<tec-icon
		name="icon-info"
		style="cursor: pointer;"
		[size]="'xs'"
		(click)="isVisibleConnectionInstructions = true; selectedConnectionType = connection"
	></tec-icon>
</ng-template>